import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const LOCAL_STORAGE_KEYS = {
  SEARCH: "search",
  STATUS: "status",
  FROM_DATE: "fromDate",
  TO_DATE: "toDate",
  LOCATION_FILTER: "locationFilter",
  CURRENTSTATUS: "currentStatus",
  QUERY: "query",
  LOANTYPE: "loanType",
  START_DATE: "startDate",
  END_DATE: "endDate",
};

// Sections that have filters
const FILTER_SECTIONS = [
  "/dashboard/customers",
  "/dashboard/loans",
  "/dashboard/guarantors",
];

export const usePreserveLocalStorage = () => {
  const location = useLocation();
  const prevPathRef = useRef(location?.pathname);

  useEffect(() => {
    const prevPath = prevPathRef.current;
    const currentPath = location?.pathname;

    // Detect which section you *were* in
    const prevSection = FILTER_SECTIONS.find((section) =>
      prevPath?.startsWith(section)
    );

    // Detect which section you *are now* in
    const currentSection = FILTER_SECTIONS.find((section) =>
      currentPath?.startsWith(section)
    );

    /**
     * If:
     *  - You were in a filter section before (customers/loans/guarantors)
     *  - AND you are now in a different section (or outside all filter sections)
     * Then: clear filters
     */
    if (prevSection && prevSection !== currentSection) {
      Object.values(LOCAL_STORAGE_KEYS).forEach((key) =>
        localStorage.removeItem(key)
      );
    }

    prevPathRef.current = currentPath;
  }, [location?.pathname]);
};
